import { Switch, Tooltip } from "@mui/material";
import React from "react";
import { handleProductMasterSwitchEvent } from "./handleProductMasterSwitchEvent";
import {
  trioActiveProductCount,
  trioMutualExclusionRecoveryMode,
} from "./trioMutualExclusionRecoveryMode";

export const createIntruderToggle = (
  selectedGroups: any,
  setSelectedGroups: any,
  setLocalProductsData: any,
  setProductsData: any,
  setGeneralInfoChangesMade: any,
  productObject: any,
  allowConcurrentLineCrossingIntruderProducts = false
) => {
  if (!allowConcurrentLineCrossingIntruderProducts) {
    const trioCount = trioActiveProductCount(selectedGroups);

    if (trioCount === 2 && !selectedGroups.intruder.selected) {
      return (
        <Tooltip
          title="Motion Plus and Line Crossing are enabled. Turn one off before enabling Intruder."
          placement="top"
        >
          <div>
            <Switch checked={false} color="warning" disabled={true} />
          </div>
        </Tooltip>
      );
    }
  }

  const trioRecoveryMode = trioMutualExclusionRecoveryMode(
    selectedGroups,
    allowConcurrentLineCrossingIntruderProducts
  );
  const trioCount = trioActiveProductCount(selectedGroups);
  const allowIntruderDespiteTrioOverlap = allowConcurrentLineCrossingIntruderProducts
    ? trioRecoveryMode && selectedGroups.intruder.selected
    : trioCount >= 3 || (trioCount === 2 && selectedGroups.intruder.selected);

  const blockers = [];
  const intruderPlusBlocking =
    selectedGroups.intruderPlus.selected ||
    (!allowIntruderDespiteTrioOverlap && selectedGroups.intruder.disabled);
  if (intruderPlusBlocking) {
    blockers.push("Intruder Plus");
  }
  if (!allowIntruderDespiteTrioOverlap && selectedGroups.motionPlus.selected) {
    blockers.push("Motion Plus");
  }
  if (
    !allowConcurrentLineCrossingIntruderProducts &&
    !allowIntruderDespiteTrioOverlap &&
    selectedGroups.lineCrossing.selected
  ) {
    blockers.push("Line Crossing");
  }

  if (blockers.length > 0) {
    const blockerText =
      blockers.length === 1
        ? blockers[0]
        : blockers.length === 2
        ? `${blockers[0]} or ${blockers[1]}`
        : `${blockers[0]}, ${blockers[1]}, or ${blockers[2]}`;
    return (
      <Tooltip
        title={`Intruder can not be run with ${blockerText} enabled. To enable Intruder, please toggle off ${blockerText}.`}
        placement="top"
      >
        <div>
          <Switch
            checked={selectedGroups.intruder.selected}
            color="warning"
            disabled={true}
          />
        </div>
      </Tooltip>
    );
  }

  return (
    <Switch
      checked={selectedGroups.intruder.selected}
      color="warning"
      disabled={false}
      onChange={(event) => {
        if (!event.target.checked) {
          setSelectedGroups((previousState: any) => {
            return {
              ...previousState,
              intruder: {
                selected: false,
                disabled: previousState.intruder.disabled,
                intruder: false,
                bike: false,
                vehicle: false,
              },
              intruderPlus: {
                selected: previousState.intruderPlus.selected,
                disabled: selectedGroups.intruderPlus.selected,
                intruder_plus: previousState.intruderPlus.intruder_plus,
                bike_plus: previousState.intruderPlus.bike_plus,
                vehicle_plus: previousState.intruderPlus.vehicle_plus,
              },
            };
          });
        }
        if (event.target.checked) {
          setSelectedGroups((previousState: any) => {
            return {
              ...previousState,
              intruder: {
                selected: true,
                disabled: previousState.intruder.disabled,
                intruder: true,
                bike: true,
                vehicle: true,
              },
              intruderPlus: {
                selected: previousState.intruderPlus.selected,
                disabled: !selectedGroups.intruderPlus.selected,
                intruder_plus: previousState.intruderPlus.intruder_plus,
                bike_plus: previousState.intruderPlus.bike_plus,
                vehicle_plus: previousState.intruderPlus.vehicle_plus,
              },
            };
          });
        }
        handleProductMasterSwitchEvent(
          setLocalProductsData,
          setProductsData,
          event,
          productObject
        );
        setGeneralInfoChangesMade(true);
      }}
    />
  );
};
